import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useEffect } from 'react';
import { useImageList } from '../../MaterialPanel/hooks/useImageList';
import { MaterialPanel } from '../MaterialPanel';
import { useRefCallback } from '@tencent/glue-react-use';
import { message } from '../../../../Message';
import { usePrefixCls } from '../../../../../config/hooks/usePrefixCls';
import { selectedMultipleImageFile } from '../../MaterialUpload/util/util';
import { IMAGE_ACCEPT_TYPES } from '../../common/const';
import { ImageStatus, startLocalUpload } from '../utils';
import { useImageListState } from '../hooks';
export var MaterialDialog = function MaterialDialog(props) {
  var visible = props.visible,
    apiConfig = props.apiConfig,
    _props$cropSizeConfig = props.cropSizeConfig,
    cropSizeConfig = _props$cropSizeConfig === void 0 ? [] : _props$cropSizeConfig,
    _props$panelStyleConf = props.panelStyleConfig,
    panelStyleConfig = _props$panelStyleConf === void 0 ? {
      panelWidth: 900,
      panelHeight: 514,
      panelCol: 3,
      panelRow: 5,
      panelItemWidth: 160
    } : _props$panelStyleConf,
    _props$uploadOpts = props.uploadOpts,
    uploadOpts = _props$uploadOpts === void 0 ? {} : _props$uploadOpts,
    onOK = props.onOK,
    onCancel = props.onCancel,
    onValueChange = props.onValueChange,
    _props$count = props.count,
    count = _props$count === void 0 ? 1 : _props$count,
    value = props.value;
  var _useImageListState = useImageListState(),
    _useImageListState2 = _slicedToArray(_useImageListState, 2),
    state = _useImageListState2[0],
    setImageListState = _useImageListState2[1];
  var description = state.description,
    uploadList = state.uploadList,
    successList = state.successList;
  var _uploadOpts$accept = uploadOpts.accept,
    accept = _uploadOpts$accept === void 0 ? IMAGE_ACCEPT_TYPES : _uploadOpts$accept;
  var _useImageList = useImageList({
      url: apiConfig.listUrl,
      request: apiConfig.request,
      uid: apiConfig.uid,
      scope: [],
      pageSize: 50
    }),
    pageInfo = _useImageList.pageInfo,
    imgList = _useImageList.imgList,
    getList = _useImageList.getList,
    isLoading = _useImageList.isLoading,
    abort = _useImageList.abort,
    reset = _useImageList.reset;
  useEffect(function () {
    if (!visible) {
      return;
    }
    getList({
      pageIndex: 1,
      description: description
    });
  }, [visible]);
  var resetPanelState = useRefCallback(function () {
    setImageListState({
      description: '',
      uploadList: [],
      successList: []
    });
    reset();
  });
  var queryChange = useRefCallback(function (val) {
    setImageListState({
      description: val
    });
    getList({
      pageIndex: 1,
      description: val
    });
  });
  var panelOk = useRefCallback(function () {
    if (value.length === 0) {
      message.error('请选择素材');
      return;
    }
    if (value.length < count) {
      message.error("\u8BF7\u9009\u62E9".concat(count, "\u5F20\u56FE\u7247"));
      return;
    }
    resetPanelState();
    onOK();
  });
  var onClose = useRefCallback(function () {
    abort();
    resetPanelState();
    onCancel();
  });
  var uploadLocalFile = function uploadLocalFile() {
    selectedMultipleImageFile({
      accept: accept,
      multiple: count !== 1
    }).then(function (fileList) {
      if (value.length + fileList.length > count) {
        var msg = "\u6700\u591A\u53EA\u80FD\u9009\u62E9".concat(count, "\u5F20\u56FE\u7247");
        message.warning(msg);
        throw new Error(msg);
      }
      var list = fileList.map(function (file) {
        return _objectSpread(_objectSpread({}, file), {}, {
          isUploading: true
        });
      });
      setImageListState({
        uploadList: list
      });
      var promiseArray = fileList.map(function (file) {
        return startLocalUpload(apiConfig.uid, file, cropSizeConfig, {
          url: apiConfig.imageUpload.localUpload.url,
          request: apiConfig.request
        });
      });
      return Promise.all(promiseArray);
    }).then(function (res) {
      var successList = [];
      var failedList = [];
      res.forEach(function (result) {
        var file = result.file,
          status = result.status,
          data = result.data,
          error = result.error;
        if (status === ImageStatus.SUCCESS && data) {
          successList.push(data);
        } else {
          failedList.push(_objectSpread(_objectSpread({}, file), {}, {
            isUploading: false,
            errorMessage: error,
            errorType: status
          }));
        }
      });
      setImageListState({
        uploadList: failedList,
        successList: successList
      });
      if (successList.length > 0) {
        onValueChange(value.concat(successList));
      }
    });
  };
  var headerOps = {
    onRefresh: function onRefresh() {
      resetPanelState();
      getList({
        pageIndex: 1,
        description: ''
      });
    },
    uploadLocalFile: uploadLocalFile,
    materialHint: React.createElement(React.Fragment, null, "\u7B26\u5408\u5F53\u524D\u89C4\u683C\u8981\u6C42\u7684\u56FE\u7247\uFF0C\u5171", React.createElement("span", {
      className: "".concat(usePrefixCls('image-panel'), "-bold")
    }, pageInfo.total), "\u4E2A\uFF0C\u4E0D\u652F\u63012021\u5E741\u6708\u524D\u4E0A\u4F20\u7684\u7D20\u6750"),
    searchValue: description,
    onSearchValueChange: queryChange
  };
  var filterList = successList.filter(function (item) {
    return !imgList.find(function (i) {
      return i.materialId === item.materialId;
    });
  });
  var listOps = {
    list: filterList.concat(imgList),
    uploadList: uploadList,
    activeImages: value,
    setActiveImages: onValueChange,
    total: pageInfo.total,
    currentPage: pageInfo.pageIndex,
    onPageChange: function onPageChange(page) {
      getList({
        pageIndex: page,
        description: description,
        mergeCurrentList: true
      });
    },
    retryUpload: function retryUpload() {
      getList({
        pageIndex: 1,
        description: ''
      }).then(uploadLocalFile);
    }
  };
  return React.createElement(MaterialPanel, {
    isLoading: isLoading,
    listOps: listOps,
    headerOps: headerOps,
    panelStyleConfig: panelStyleConfig,
    onOk: panelOk,
    onCancel: onClose,
    show: visible,
    max: count
  });
};